import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { filter, finalize, takeUntil } from 'rxjs';
import {
  MsalModule,
} from '@azure/msal-angular';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import {
  AuthenticationResult,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { LoginService } from '../../shared/services/login.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Respuesta } from '../../shared/models';
import { HeadersStore } from '../../shared/store/headers.store';
import { PerfilStore } from '../../shared/store/perfil.store';
import { da } from 'date-fns/locale';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, NzIconModule, NzSpinModule, NzModalModule, NzInputModule, NzButtonModule, NzFormModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private router: Router,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private loginService: LoginService,
    private message: NzMessageService,
    private cdr: ChangeDetectorRef,
    private perfilStore: PerfilStore,
    private headersStore: HeadersStore
  ) { }
  appVersion: string = environment.version;
  private readonly _destroying$ = new Subject<void>();
  cargandoInicioDeSesion: boolean = false;
  cargandoSolicitud: boolean = false;
  isIframe = false;
  loginDisplay = false;
  loading: boolean = false;
  
  isModalVisible = false;
  email = '';
  password = '';
  modalLoading = false;


    ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe();
    this.isIframe = window !== window.parent && !window.opener;
    this.authService.instance.enableAccountStorageEvents();
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/';
        } else {
          this.setLoginDisplay();
        }
      });
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });
  }

    setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;

  }


  /**
   * @description Checks if there is an active account and sets it if not.
   * This method is called to ensure that the active account is set correctly
   * when the component initializes or when the user logs in.
   */
  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
      activeAccount = accounts[0];
    }
    if(activeAccount) {
      this.login(activeAccount)
    }
  }

    loginPopup() {
    if (this.msalGuardConfig.authRequest) {
      this.authService
        .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe(
          {
            next: (response: AuthenticationResult) => {
              this.authService.instance.setActiveAccount(response.account);
              this.login(response);
            },
            error: (error) => {
            },
          }
        );
    } else {
      this.authService
        .loginPopup()
        .subscribe({
          next: (response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.login(response);
          },
          error: (error) => {
          }
        });
    }
  }

    loginRedirect() {
    this.loading = true;
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  private login( data:any) {
    this.loading = true;
    this.headersStore.SetTKNType(data?.idToken || '');
    this.loginService.login( 
      data?.idTokenClaims?.email || '', data.idToken || '')
      .pipe(
        finalize(() => {
          this.loading = false;
           this.cdr.detectChanges();
          }
        )
      )
      .subscribe({
      next: (response: any) => {
          if(response?.success) {
            this.perfilStore.setPerfil(response.details.usuario);
            this.perfilStore.setPerfilAD(data || { username: data?.idTokenClaims?.email });
            this.headersStore.SetTKN(response.details.token);
            this.router.navigate(['/home']);
          }
          else {
            this.message.error('Error al iniciar sesión');
          }
      },
      error: (error) => {
        this.message.error('Error al iniciar sesión');
      }
    });
  }

  showModal(): void {
    this.isModalVisible = true;
  }

  handleCancel(): void {
    this.isModalVisible = false;
    this.email = '';
    this.password = '';
  }

  handleOk(): void {
    if (this.email) {
      this.modalLoading = true;
      // this.loginManual();
    } else {
      this.message.error('Por favor ingresa un email válido');
    }
  }

  // loginManual(): void {
  //   this.modalLoading = true;
  //   this.headersStore.SetTKNType(this.tkn)
  //   this.loginService.login(this.email, this.tkn)
  //     .pipe(
  //       finalize(() => {
  //         this.modalLoading = false;
  //         this.cdr.detectChanges();
  //       })
  //     )
  //     .subscribe({
  //       next: (response: any) => {
  //         if(response?.success) {
  //           this.perfilStore.setPerfil(response.details.usuario);
  //           this.perfilStore.setPerfilAD({ username: this.email });
  //           this.headersStore.SetTKN(response.details.token);
  //           this.isModalVisible = false;
  //           this.email = '';
  //           this.password = '';
  //           this.router.navigate(['/home']);
  //         }
  //         else {
  //           this.message.error('Error al iniciar sesión');
  //         }
  //       },
  //       error: (error) => {
  //         this.message.error('Error al iniciar sesión');
  //       }
  //     });
  // }
}
